import { render } from "./BarChartB.vue?vue&type=template&id=c88939bc&scoped=true"
import script from "./BarChartB.vue?vue&type=script&lang=ts"
export * from "./BarChartB.vue?vue&type=script&lang=ts"

import "./BarChartB.vue?vue&type=style&index=0&id=c88939bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c88939bc"

export default script